<template>
  <div class="hue" @mousedown.prevent.stop="selectHue">
    <canvas ref="canvasHue" class="canvas" />
    <div :style="slideHueStyle" class="slide" />
  </div>
</template>

<script>
export default {
  props: {
    hsv: {
      type: Object,
      default: null,
    },
    width: {
      type: Number,
      default: 208,
    },
    height: {
      type: Number,
      default: 8,
    },
    color: {
      type: String,
      default: '#000000',
    },
  },
  data() {
    return {
      slideHueStyle: {},
    };
  },
  watch: {
    hsv() {
      this.slideHueStyle = { ...this.slideHueStyle, background: this.color };
    },
  },
  mounted() {
    this.renderColor();
    this.renderSlide();
  },
  methods: {
    renderColor() {
      const canvas = this.$refs.canvasHue;
      const width = this.width;
      const height = this.height;
      const ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;

      const gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, '#FF0000');
      gradient.addColorStop(0.17, '#FF00FF');
      gradient.addColorStop(0.17 * 2, '#0000FF');
      gradient.addColorStop(0.17 * 3, '#00FFFF');
      gradient.addColorStop(0.17 * 4, '#00FF00');
      gradient.addColorStop(0.17 * 5, '#FFFF00');
      gradient.addColorStop(1, '#FF0000');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);
    },
    renderSlide() {
      const left = (1 - this.hsv.h / 360) * this.width - 2 - 8 + 'px';
      this.slideHueStyle = {
        left: left,
        background: this.color,
      };
    },
    selectHue(e) {
      const { left: hueLeft } = this.$el.getBoundingClientRect();
      const ctx = this.$refs.canvasHue.getContext('2d');

      const mousemove = (e) => {
        let x = e.clientX - hueLeft;

        if (x < 0) {
          x = 0;
        }
        if (x > this.width) {
          x = this.width;
        }

        this.slideHueStyle = {
          left: x - 7 + 'px',
        };

        const imgData = ctx.getImageData(Math.min(x, this.width - 1), 0, 1, 1);
        const [r, g, b] = imgData.data;
        this.$emit('selectHue', { r, g, b });
      };

      mousemove(e);

      const mouseup = () => {
        document.removeEventListener('mousemove', mousemove);
        document.removeEventListener('mouseup', mouseup);
      };

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
    },
  },
};
</script>

<style scoped lang="scss">
.hue {
  position: relative;
  cursor: pointer;

  .slide {
    position: absolute;
    top: 4px;
    border: 1px solid rgb(255, 255, 255);
    width: 16px;
    height: 16px;
    box-sizing: border-box;
    transform: rotate(90deg);
    border-radius: 100%;
    cursor: ew-resize;
    background: #ff0000;
  }

  .canvas {
    border-radius: 5px;
    display: inline;
    vertical-align: unset;
  }
}
</style>
